import { render, staticRenderFns } from "./statisticsUserRoleSettingInfo.vue?vue&type=template&id=2339b945&"
import script from "./statisticsUserRoleSettingInfo.vue?vue&type=script&lang=js&"
export * from "./statisticsUserRoleSettingInfo.vue?vue&type=script&lang=js&"
import style0 from "./statisticsUserRoleSettingInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports